import React, { FC, ReactNode } from "react";
import classNames from "classnames";

type Props = {
  icon?: ReactNode;
  text: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  dataTest?: string;
  onClick?: () => void;
};

export const SelectionPill: FC<Props> = ({
  icon,
  text,
  selected,
  disabled,
  dataTest,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        "flex items-center gap-2 p-2 w-22 h-10 rounded-[48px] cursor-pointer theme-border text-gray-200",
        {
          "bg-gray-500 text-white": !!selected,
          "bg-gray-50": !!disabled,
        }
      )}
      data-selected={!!selected}
      data-disabled={!!disabled}
      data-test={dataTest}
      onClick={!disabled ? onClick : undefined}
    >
      <div data-test={`${dataTest}-icon`}>{icon}</div>

      <div data-test={`${dataTest}-text`}>{text}</div>
    </div>
  );
};
